import {usePromotion} from '@/context/Promotion/PromotionContext'
import {PromotionType} from '@/types/promotion'

const values = [
  {id: false, displayText: 'cannot combine'},
  {id: true, displayText: 'can combine'},
]

export const useProductCombination = () => {
  const {
    promotion: {promotionConditions, promotionType},
    updatePromotion,
  } = usePromotion()

  const isVisible = promotionType === PromotionType.BUY_SINGLE_PRODUCT

  const conditions = promotionConditions?.flatMap(pc => pc.conditionGroup?.conditions ?? []) ?? []

  const canCombine = conditions.length > 0 && conditions.every(c => c.productCombination === true)
  const selectedValue = canCombine ? values[1] : values[0]

  const handleUpdateValue = value => {
    const productCombination = value[0]?.id ?? false

    updatePromotion(prev => {
      const updatedPromotionConditions = prev.promotionConditions?.map(pc => {
        if (!pc.conditionGroup?.conditions) {
          return pc
        }

        return {
          ...pc,
          conditionGroup: {
            ...pc.conditionGroup,
            conditions: pc.conditionGroup.conditions.map(c => {
              return {
                ...c,
                productCombination,
              }
            }),
          },
        }
      })

      return {
        ...prev,
        promotionConditions: updatedPromotionConditions,
      }
    })
  }

  return {
    isVisible,
    values,
    selectedValue,
    handleUpdateValue,
  }
}
